import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  Alert,
  Card, CardBody, CardTitle, Col, Row
} from 'reactstrap';
import api from '../../../api/api';
import apifunctions from '../../../api/functions';

export const LotesDisponibles = ({ filter }) => {
  const [state, setState] = useState({
    total: 0,
    disponibles: 0,
    vendidos: 0,
  });
  useEffect(() => {
    const successCallback = (response) => {
      if(response && response.data){
        setState({
          ...response.data
        })
      } else {
        setState({
          total: 0,
          disponibles: 0,
          vendidos: 0,
        })
      }
    }
    const failureCallback = () => {
      setState({
        total: 0,
        disponibles: 0,
        vendidos: 0,
      })
    }
    apifunctions.get(api.inversionista.disponibilidad, null, null, {}, successCallback, failureCallback, failureCallback)
  }, [filter])
  return (
    <Col xs={12}>
      <Card>
        <CardBody>
          <CardTitle>Disponibilidad de Lotes</CardTitle>
          <Row>
            <Col>
              <Alert color="secondary" className="text-center">
                Total: {state.total}
              </Alert>
            </Col>
            <Col>
              <Alert color="info" className="text-center">
                Comprados: {state.vendidos}
              </Alert>
            </Col>
            <Col>
              <Alert color="success" className="text-center">
                Disponibles: {state.disponibles}
              </Alert>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/views/Inversionistas/Resumen/LotesDisponibles.js